import { useSelector } from "react-redux";

export const useUser = () => {
    const user = useSelector((state:any)=>state.Auth.user);
    return user;
};
  